const kebabCaseCheck = (input: string): string =>
  input
    .split(/(?=[A-Z])/)
    .join("-")
    .toLowerCase();

export const camelToKebabConverter = (
  name: string | undefined = "",
): string => {
  return kebabCaseCheck(name);
};
